import React, { Component } from "react";
import './360ViewerStyles.css'
import {DBGLoadingSpinner} from "./DBGLoadingSpinner"
import Hammer from 'react-hammerjs';

const MenuButton = (props) => {
    return (
        <div className="DBG-menu-btn" onClick={props.clicked}>
            <i className={props.icon}></i>{props.text}
        </div>
    )
}

class React360Viewer extends Component {

    constructor() {
        super();
        //this.imageContainerRef = React.createRef();
        this.viewPercentageRef = React.createRef();
        this.viewPortElementRef = React.createRef();
        this.AppContainerRef = React.createRef();
        this.radialProgressRef = React.createRef();
        this.canvas = null
        this.ctx = null
        this.isMobile = false
        this.imageData = []
        this.images = []
        this.loadedImages = 0
        this.loadFirstFrame = false;
        this.viewerPercentage = null
        this.radialProgress = null
        this.currentImage = null
        this.currentLeftPosition = this.currentTopPosition = 0
        this.currentCanvasImage = null
        this.centerX = 0
        this.centerY = 0
        this.movementStart = 0
        this.movement = false
        this.speedFactor = 13
        this.activeImage = 1
        this.stopAtEdges = false
        this.dpi = 0
        this.mobilePinching = false;

        this.state = {
            lastX: 0,
            lastY: 0,
            minScale: 0.5,
            maxScale: 4,
            scale: 0.2,
            customOffset: 10,
            currentScale: 1,
            currentTopPosition: 0,
            currentLeftPosition: 0,
            selectMenuOption: 1,
            currentImage: null,
            dragging: false,
            canvas: null,
            ctx: null,
            dragStart: null,
            currentCanvasImage: null,
            isFullScreen: false,
            viewPortElementWidth: null,
            movementStart: 0,
            movement: false,
            dragSpeed: 150,
            speedFactor: 13,
            activeImage: 1,
            stopAtEdges: false,
            panmode: false,
            currentLoop: 0,
            loopTimeoutId: 0,
            RefreshImageTimeoutId: 0,
            playing: false,
            imagesLoaded: false,
            AppContainerElement: null
        }

        //this.currentLeftPosition = this.currentLeftPosition.bind(this)
    }

    componentDidMount(){
        this.disableZoomin()

        this.viewerPercentage = this.viewPercentageRef.current;
        this.radialProgress = this.radialProgressRef.current;
        this.radialProgress.style.setProperty('--progress', '1%')
        //console.log(this.viewerContainerRef.getElementsByClassName('v360-viewport-container'))
        this.viewPortElementRef = this.viewerContainerRef.getElementsByClassName('v360-viewport-container')[0];

        this.AppContainerRef = document.getElementById(this.props.containerID);
        if(this.AppContainerRef != null){
            this.AppContainerRef.classList.add('DBG-Dropshadow')
            this.AppContainerElement = this.AppContainerRef.getBoundingClientRect()
            //console.log("width: " + this.AppContainerElement.width + " height: " + this.AppContainerElement.height);
        }
        
        if (this.props.preloadImages && this.loadFirstFrame === false)
        {
            this.fetchData()
        }
        else
        {
            this.fetchFirstImage()
            this.loadFirstFrame = true;
        }

        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
        this.stop();
    }
    
    handleResize = () => {
        if(this.AppContainerRef != null){
            this.AppContainerElement = this.AppContainerRef.getBoundingClientRect()
            //console.log("width: " + this.AppContainerElement.width + " height: " + this.AppContainerElement.height);
        }
        this.setImage();
        this.checkMobile()
    };

    fetchData(){
        for(let i=1; i <= this.props.amount; i++){
            const imageIndex = (this.props.paddingIndex) ? this.lpad(i, "0", 2) : i
            const fileName = this.props.fileName.replace('{index}', imageIndex);
            const filePath = `${this.props.imagePath}/${fileName}`
            this.imageData.push(filePath)
        }

        this.preloadImages()
    }

    fetchFirstImage(){

        const imageIndex = (this.props.paddingIndex) ? this.lpad(1, "0", 2) : 1
        const fileName = this.props.fileName.replace('{index}', imageIndex);
        const filePath = `${this.props.imagePath}/${fileName}`
        this.imageData.push(filePath)

        this.preloadImages()
    }

    lpad(str, padString, length) {
        str = str.toString()
        while (str.length < length) str = padString + str
        return str
    }

    preloadImages() {
        if (this.imageData.length) {
            try {
                //this.props.amount = this.imageData.length;
                this.imageData.forEach(src => {
                    this.addImage(src);
                });
            } catch (error) {
                console.error(`Something went wrong while loading images: ${error.message}`);
            }
        } else {
            console.log('DBG: No Images Found')
        }
    }

    addImage(resultSrc){
        const image = new Image();
        image.src = resultSrc;
        //image.crossOrigin='anonymous'
        image.onload = this.onImageLoad.bind(this);
        image.onerror = this.onImageLoad.bind(this);
        this.images.push(image);
    }

    onImageLoad(event) {
        const percentage = Math.round(this.loadedImages / this.props.amount * 100);
        this.loadedImages += 1;
        this.updatePercentageInLoader(percentage);
        if (this.loadedImages === this.props.amount) {
            this.onAllImagesLoaded(event);
        } else if (this.loadedImages === 1) {
            //this.onFirstImageLoaded(event);
            //console.log('DBG: Loading first image')
            if(this.loadFirstFrame)
            {
                this.onAllImagesLoaded(event);
            }
        }
    }

    updatePercentageInLoader(percentage) {
        /* if (this.loader) {
            this.loader.style.width = percentage + '%';
        }
        if (this.view360Icon) {
            this.view360Icon.innerText = percentage + '%';
        } */
        this.viewerPercentage = this.viewPercentageRef.current;
        this.radialProgress = this.radialProgressRef.current;

        if (percentage >= 100)
        {
            percentage = 100;
        }

        if (this.viewerPercentage !== null && this.radialProgress !== null)
        {
            this.viewerPercentage.innerHTML = percentage + '%';
            this.radialProgress.style.setProperty('--progress', percentage + '%')
            this.radialProgress.setAttribute('aria-valuenow', percentage + '%')
        }
    }

    onAllImagesLoaded(e){
        this.setState({ imagesLoaded: true })
        
        this.initData()
    }

    initData(){
        //console.log(this.imageContainerRef)
        this.canvas = this.imageContainerRef
        if (this.canvas == null) return;
        this.ctx = this.canvas.getContext('2d')
        //console.log('initialize data here')
                
        //get DPI
        this.dpi = window.devicePixelRatio;

        this.attachEvents();
        this.checkMobile()
        this.loadInitialImage()

        this.setState({ playing: this.props.autoplay })
    }

    attachEvents(){
        if(this.state.panmode){
            this.bindPanModeEvents()
        }else{
            this.bind360ModeEvents()
        }
    }

    bindPanModeEvents(){
        this.viewPortElementRef.removeEventListener('touchend', this.touchEnd);
        this.viewPortElementRef.removeEventListener('touchstart', this.touchStart);
        this.viewPortElementRef.removeEventListener('touchmove', this.touchMove); 

        this.viewPortElementRef.addEventListener('touchend', this.stopDragging);
        this.viewPortElementRef.addEventListener('touchstart', this.startDragging);
        this.viewPortElementRef.addEventListener('touchmove', this.doDragging); 

        this.viewPortElementRef.removeEventListener('mouseup', this.stopMoving);
        this.viewPortElementRef.removeEventListener('mousedown', this.startMoving);
        this.viewPortElementRef.removeEventListener('mousemove', this.doMoving); 
        
        this.viewPortElementRef.addEventListener('mouseup', this.stopDragging);
        this.viewPortElementRef.addEventListener('mousedown', this.startDragging);
        this.viewPortElementRef.addEventListener('mousemove', this.doDragging); 
    }
    
    bind360ModeEvents(){
        this.viewPortElementRef.removeEventListener('touchend', this.stopDragging);
        this.viewPortElementRef.removeEventListener('touchstart', this.startDragging);
        this.viewPortElementRef.removeEventListener('touchmove', this.doDragging); 

        this.viewPortElementRef.addEventListener('touchend', this.touchEnd);
        this.viewPortElementRef.addEventListener('touchstart', this.touchStart);
        this.viewPortElementRef.addEventListener('touchmove', this.touchMove); 

        this.viewPortElementRef.removeEventListener('mouseup', this.stopDragging);
        this.viewPortElementRef.removeEventListener('mousedown', this.startDragging);
        this.viewPortElementRef.removeEventListener('mousemove', this.doDragging); 
        
        this.viewPortElementRef.addEventListener('mouseup', this.stopMoving);
        this.viewPortElementRef.addEventListener('mousedown', this.startMoving);
        this.viewPortElementRef.addEventListener('mousemove', this.doMoving);
    }

    startDragging = (evt) => {
        if (!this.mobilePinching){
            this.dragging = true
            document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
            this.setLastPositions(evt)
            
            this.dragStart = this.ctx.transformedPoint(this.state.lastX,this.state.lastY);
        }
    }

    setLastPositions(evt){
        var rect = this.canvas.getBoundingClientRect(),
        scaleX = this.canvas.width / rect.width,    // relationship bitmap vs. element for x
        scaleY = this.canvas.height / rect.height;  // relationship bitmap vs. element for y

        if(this.isMobile){

            if(evt.touches !== undefined)
            {
                this.setState({ 
                    lastX: (evt.touches[0].clientX - rect.left) * scaleX,
                    lastY: (evt.touches[0].clientY - rect.top) * scaleY
                })

                //console.log("LastX: " + this.state.lastX +  " LastY: " + this.state.lastY);
            }
            else
            {
                this.setState({ 
                    lastX: (evt.clientX - rect.left) * scaleX,
                    lastY: (evt.clientY - rect.top) * scaleY
                })

            }

        }else{
            this.setState({ 
                lastX: (this.state.isFullScreen) ? (evt.clientX - this.canvas.offsetTop): (evt.clientX - rect.left) * scaleX,
                lastY: (this.state.isFullScreen) ? (evt.clientY - this.canvas.offsetLeft): (evt.clientY - rect.top) * scaleY
            })
        }
    }

    HandleKeyDown = (evt) => {
        
        if(evt.key === "Shift")
        {
            if (evt.repeat) { return }
            this.togglePanMode();
        }
    }

    HandleKeyUp = (evt) => {
        if(evt.key === "Shift")
        {
            this.togglePanMode();
        }

    }

    doDragging = (evt) => {
        
        this.setLastPositions(evt)
        
        if (this.dragStart){
            let pt = this.ctx.transformedPoint(this.state.lastX,this.state.lastY);
            this.ctx.translate(pt.x-this.dragStart.x,pt.y-this.dragStart.y);
            //redraw();
            this.redraw();
        }
    }

    stopDragging = (evt) => {
        this.dragging = false
        this.dragStart = null
    }

    checkMobile(){
        this.isMobile = !!('ontouchstart' in window || navigator.msMaxTouchPoints);
    }

    loadInitialImage(){
        this.currentImage = this.imageData[0] 
        this.setImage()
        //SetTimer to reload after 100ms because Safari is DooDoo
        this.setState({
            RefreshImageTimeoutId: window.setInterval(() => this.TimerReload(), 10)
        })
    }

    stopReloadInterval() {
        window.clearTimeout(this.state.RefreshImageTimeoutId);
    }

    TimerReload() {
        this.setImage(true);
        this.stopReloadInterval();
    }

    setImage(cached = false){
        this.currentLeftPosition = this.currentTopPosition = 0
        
        if(!cached){
            this.currentCanvasImage = new Image()
            this.currentCanvasImage.crossOrigin='anonymous'
            this.currentCanvasImage.src = this.currentImage
            this.currentCanvasImage.onload = () => {
                let viewportElement = this.viewPortElementRef.getBoundingClientRect()

                this.canvas.width  = (this.state.isFullScreen) ? viewportElement.width * this.dpi : (this.AppContainerElement.width * this.dpi);
                this.canvas.height = (this.state.isFullScreen) ? viewportElement.height * this.dpi : (this.AppContainerElement.height * this.dpi) ;
        
                this.canvas.style.width = (this.state.isFullScreen) ? `${viewportElement.width}px` : `${this.AppContainerElement.width}px` ;
                this.canvas.style.height = (this.state.isFullScreen) ? `${viewportElement.height}px` : `${this.AppContainerElement.height}px` ;

                this.trackTransforms(this.ctx)
                this.redraw()
                console.log('DBG: Image loaded successfully')
            }
            this.currentCanvasImage.onerror = () => {
                console.log('DBG: Failed to load image, check JSON configuration / Image folder')
            }
        }else{
            this.currentCanvasImage = this.images[0]
            let viewportElement = this.viewPortElementRef.getBoundingClientRect()

            this.canvas.width  = (this.state.isFullScreen) ? viewportElement.width * this.dpi : (this.AppContainerElement.width * this.dpi);
            this.canvas.height = (this.state.isFullScreen) ? viewportElement.height * this.dpi : (this.AppContainerElement.height * this.dpi) ;
    
            this.canvas.style.width = (this.state.isFullScreen) ? `${viewportElement.width}px` : `${this.AppContainerElement.width}px` ;
            this.canvas.style.height = (this.state.isFullScreen) ? `${viewportElement.height}px` : `${this.AppContainerElement.height}px` ;

            this.trackTransforms(this.ctx)
            this.redraw()
        }
        
    }

    setImageZoom(){
        this.currentLeftPosition = this.currentTopPosition = 0
        let viewportElement = this.viewPortElementRef.getBoundingClientRect()

        this.canvas.width  = (this.state.isFullScreen) ? viewportElement.width * this.dpi : (this.AppContainerElement.width * this.dpi);
        this.canvas.height = (this.state.isFullScreen) ? viewportElement.height * this.dpi : (this.AppContainerElement.height * this.dpi) ;

        this.canvas.style.width = (this.state.isFullScreen) ? `${viewportElement.width}px` : `${this.AppContainerElement.width}px` ;
        this.canvas.style.height = (this.state.isFullScreen) ? `${viewportElement.height}px` : `${this.AppContainerElement.height}px` ;
        this.trackTransforms(this.ctx)
        this.redraw()
    }

    redraw(){
        try {
            let p1 = this.ctx.transformedPoint(0,0);
            let p2 = this.ctx.transformedPoint(this.canvas.width,this.canvas.height)
            let hRatio = this.canvas.width / this.currentCanvasImage.width
            let vRatio =  this.canvas.height / this.currentCanvasImage.height
            let ratio  = Math.min(hRatio, vRatio);
            let centerShift_x = Math.round((this.canvas.width - this.currentCanvasImage.width*ratio )/2)
            let centerShift_y = Math.round((this.canvas.height - this.currentCanvasImage.height*ratio )/2)
            this.ctx.clearRect(p1.x,p1.y,p2.x-p1.x,p2.y-p1.y);
            this.centerX = this.canvas.width/2
            this.centerY = this.canvas.height/2
            

            this.ctx.drawImage(this.currentCanvasImage, this.currentLeftPosition, this.currentTopPosition, this.currentCanvasImage.width, this.currentCanvasImage.height,
                        centerShift_x,centerShift_y, Math.round(this.currentCanvasImage.width*ratio), Math.round(this.currentCanvasImage.height*ratio));  

        }
        catch(e){
            this.trackTransforms(this.ctx)
        }
    }

    trackTransforms(ctx){
        return new Promise(resolve => {
            var svg = document.createElementNS("http://www.w3.org/2000/svg",'svg');
            var xform = svg.createSVGMatrix();
            this.ctx.getTransform = function(){ return xform; };
            
            var savedTransforms = [];
            var save = ctx.save;
            this.ctx.save = () => {
                savedTransforms.push(xform.translate(0,0));
                return save.call(this.ctx);
            };
            var restore = ctx.restore;
            this.ctx.restore = () => {
                xform = savedTransforms.pop();
                return restore.call(this.ctx);
            };
            var scale = this.ctx.scale;
            this.ctx.scale = (sx,sy) => {
                xform = xform.scaleNonUniform(sx,sy);
                return scale.call(this.ctx,sx,sy);
            };
            var rotate = this.ctx.rotate;
            this.ctx.rotate = (radians) => {
                xform = xform.rotate(radians*180/Math.PI);
                return rotate.call(this.ctx,radians);
            };
            var translate = this.ctx.translate;
            this.ctx.translate = (dx,dy) => {
                xform = xform.translate(dx,dy);
                return translate.call(this.ctx,dx,dy);
            };
            var transform = this.ctx.transform;
            this.ctx.transform = (a,b,c,d,e,f) => {
                var m2 = svg.createSVGMatrix();
                m2.a=a; m2.b=b; m2.c=c; m2.d=d; m2.e=e; m2.f=f;
                xform = xform.multiply(m2);
                return transform.call(this.ctx,a,b,c,d,e,f);
            };
            var setTransform = this.ctx.setTransform;
            this.ctx.setTransform = (a,b,c,d,e,f) => {
                xform.a = a;
                xform.b = b;
                xform.c = c;
                xform.d = d;
                xform.e = e;
                xform.f = f;
                return setTransform.call(this.ctx,a,b,c,d,e,f);
            };
            var pt  = svg.createSVGPoint();
            this.ctx.transformedPoint = (x,y) => {
                pt.x=x; pt.y=y;
                return pt.matrixTransform(xform.inverse());
            }
            resolve(this.ctx)
        })
        
    }

    prev = (e) => {
        //console.log(this.currentLeftPosition)
        /* this.setState({
            currentLeftPosition: 10
        }) */
        //this.currentLeftPosition = 10
        (this.props.spinReverse) ? this.turnRight() : this.turnLeft()
    }

    next = (e) => {
        (this.props.spinReverse) ? this.turnLeft() : this.turnRight()
    }

    resetPosition = () => {
        this.currentScale = 1
        this.activeImage = 1
        this.setImage(true)
    }

    turnLeft(){
        this.moveActiveIndexDown(1);
    }

    turnRight(){
        this.moveActiveIndexUp(1);
    }

    moveActiveIndexUp(itemsSkipped) {
        if (this.stopAtEdges) {
            if (this.activeImage + itemsSkipped >= this.props.amount) {
                this.activeImage = this.props.amount;
            } else {
                this.activeImage += itemsSkipped;
            }
        } else {
            this.activeImage = (this.activeImage + itemsSkipped) % this.props.amount || this.props.amount;
        }
        
        this.update()
    }

    moveActiveIndexDown(itemsSkipped) {
        if (this.stopAtEdges) {
            if (this.activeImage - itemsSkipped <= 1) {
                this.activeImage = 1;
            } else {
                this.activeImage -= itemsSkipped;
            }
        } else {
            if (this.activeImage - itemsSkipped < 1) {
                this.activeImage = this.props.amount + (this.activeImage - itemsSkipped);
            } else {
                this.activeImage -= itemsSkipped;
            }
        }
        
        this.update()
    }

    update() {
        const image = this.images[this.activeImage - 1];
        this.currentCanvasImage = image
/*         let viewportElement = this.viewPortElementRef.getBoundingClientRect()
        this.canvas.width  = (this.state.isFullScreen) ? viewportElement.width : viewportElement.width
        this.canvas.height = (this.state.isFullScreen) ? viewportElement.height : viewportElement.height */
        this.redraw()
    }

    zoomImage = (evt) => {

        if(!this.state.imagesLoaded){
            return;
        }
        
        var rect = this.canvas.getBoundingClientRect(),
        scaleX = this.canvas.width / rect.width,    // relationship bitmap vs. element for x
        scaleY = this.canvas.height / rect.height;  // relationship bitmap vs. element for y

        this.setState({ 
            lastX: (this.state.isFullScreen) ? (evt.clientX - this.canvas.offsetTop): (evt.clientX - rect.left) * scaleX,
            lastY: (this.state.isFullScreen) ? (evt.clientY - this.canvas.offsetLeft): (evt.clientY - rect.top) * scaleY
        })
        
        var delta = evt.wheelDelta ? evt.wheelDelta/40 : evt.deltaY ? -evt.deltaY : 0;
        
        delta = delta/10;
        if (delta) this.zoom(delta);
        //return evt.preventDefault() && false;
            
    }

    zoomIn = (evt) => {

        if(!this.state.imagesLoaded){
            return;
        }

        this.setState({ 
            lastX: this.centerX,
            lastY: this.centerY
        })
        //this.lastY = this.centerY
        this.zoom(2)
    }

    zoomOut = (evt) => {
        if(!this.state.imagesLoaded){
            return;
        }

        this.setState({ 
            lastX: this.centerX,
            lastY: this.centerY
        })
        this.zoom(-2)
    }

    zoomInButton = (evt) => {
        this.setState({ 
            lastX: this.centerX,
            lastY: this.centerY
        })
        //this.lastY = this.centerY
        this.zoom(10)
    }
    
    zoomOutButton = (evt) => {
        this.setState({ 
            lastX: this.centerX,
            lastY: this.centerY
        })
        this.zoom(-10)
    }

    zoom(clicks){
        //console.log(this.lastX + ' - ' + this.lastY)
        let factor = 1+(clicks*0.01);

        //console.log(factor)
        if(factor > 1){
            this.currentScale = this.currentScale*factor;
        }else{
            if(this.currentScale*factor > 1)
                this.currentScale = this.currentScale*factor;
            else
                this.currentScale = 1
        }
        
        if(this.currentScale > 1){
            let pt = this.ctx.transformedPoint(this.state.lastX,this.state.lastY);
            this.ctx.translate(pt.x,pt.y);
            
            //console.log(this.currentScale)
            this.ctx.scale(factor,factor);
            this.ctx.translate(-pt.x,-pt.y);
            this.redraw();
        }
        else{
            this.resetZoom();
        }
        //console.log("clicks"+clicks);
        //console.log("factor"+factor);
        //console.log("currentscale"+this.currentScale);
    }

    resetZoom = () => {
        this.currentScale = 1
        this.setImageZoom();
    }

    disableZoomin(){
        document.addEventListener("gesturestart", function (e) {
          e.preventDefault();
            document.body.style.zoom = 0.99;
        });
        document.addEventListener("gesturechange", function (e) {
          e.preventDefault();
          document.body.style.zoom = 0.99;
        });
        
        document.addEventListener("gestureend", function (e) {
            e.preventDefault();
            document.body.style.zoom = 1;
        });
    }


    onMove(pageX){
        if (pageX - this.movementStart >= this.speedFactor) {
            let itemsSkippedRight = Math.floor((pageX - this.movementStart) / this.speedFactor) || 1;
            
            this.movementStart = pageX;
            if (this.props.spinReverse) {
                this.moveActiveIndexDown(itemsSkippedRight);
            } else {
                this.moveActiveIndexUp(itemsSkippedRight);
            }
            this.redraw();
        } else if (this.movementStart - pageX >= this.speedFactor) {
            let itemsSkippedLeft = Math.floor((this.movementStart - pageX) / this.speedFactor) || 1;
            
            this.movementStart = pageX;
            if (this.props.spinReverse) {
                this.moveActiveIndexUp(itemsSkippedLeft);
            } else {
                this.moveActiveIndexDown(itemsSkippedLeft);
            }
            this.redraw();
        }
    }

    startMoving = (evt) => {
        if (!this.mobilePinching){
            this.movement = true
            this.movementStart = evt.clientX;
            this.viewPortElementRef.style.cursor = 'grabbing';
        }
    }

    doMoving = (evt) => {
        if(this.movement && !this.mobilePinching){
            this.onMove(evt.clientX)
        }
    }

    stopMoving = (evt) => {
        this.movement = false
        this.movementStart = 0
        this.viewPortElementRef.style.cursor = 'grab'
    }

    touchStart = (evt) => {
        if (!this.mobilePinching){
            this.movementStart = evt.changedTouches[0].clientX
        }
    }

    touchMove = (evt) => {
        if (!this.mobilePinching){
            this.onMove(evt.touches[0].clientX)
        }
    }

    touchEnd = () => {
        this.movementStart = 0
    }

    play = (e) => {
        this.setState({
            loopTimeoutId: window.setInterval(() => this.loopImages(), 25)
        })
    }

    onSpin() {
        if (this.state.playing || this.state.loopTimeoutId) {
            this.stop();
        }
    }

    stop() {
        if(this.activeImage === 1){
            this.setState({ currentLoop: 0 })
        }
        this.setState({ playing: false })
        window.clearTimeout(this.state.loopTimeoutId);
    }

    loopImages() {
        let loop = (this.props.loop) ? this.props.loop : 1

        if(this.activeImage === 1){
            if(this.state.currentLoop === loop){
                this.stop()
            }
            else{
                this.setState({ currentLoop: this.state.currentLoop + 1 })
                
                this.next()
            }
        }
        else{
            this.next()
        }
    }

    togglePlay = (e) => {
        this.setState({ playing: !this.state.playing })
    }

    togglePanMode = (e) => {
       
        //if(this.isMobile == false){

            this.setState({ panmode: !this.state.panmode })

            if(!this.state.panmode){
                //PanmodeActive
                this.NotificationDivRef.classList.remove('DBG-Notification-Hide')
                this.NotificationDivRef.classList.add('DBG-Notification-Show')
            }
            else{
                //PanmodeInactive
                this.NotificationDivRef.classList.remove('DBG-Notification-Show')
                this.NotificationDivRef.classList.add('DBG-Notification-Hide')
            }
       // }
    }

    toggleFullScreen = (e) => {
        this.setState({ isFullScreen: !this.state.isFullScreen })
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.currentLeftPosition !== prevState.currentLeftPosition){
            console.log('Left Position Changed')
        }

        if(this.state.panmode !== prevState.panmode){
            this.attachEvents()
        }

        if(this.state.playing !== prevState.playing){
            if(!this.state.playing){
                this.stop()
            }else{
                this.play()
            }
        }
        if(this.state.isFullScreen !== prevState.isFullScreen){
            if(!this.state.isFullScreen){
                //exit full screen
                this.AppContainerRef.classList.add('DBG-Dropshadow')
                this.viewerContainerRef.classList.remove('v360-main')
                this.viewerContainerRef.classList.remove('v360-fullscreen')
                this.MenuButtonContainerRef.classList.remove('DBG-menu-bottom')
            }else{
                //enter full screen
                this.AppContainerRef.classList.remove('DBG-Dropshadow')
                this.viewerContainerRef.classList.add('v360-main')
                this.viewerContainerRef.classList.add('v360-fullscreen')
                this.MenuButtonContainerRef.classList.add('DBG-menu-bottom')
            }
            this.setImage()
        }
    }

    handlePinch = (e) => {
        
        if (e.scale > 1) {
        // zoom in
            this.zoomIn();
        } else if (e.scale < 1) {
        // zoom out
            this.zoomOut();
        }
    }

    handleTap = (e) => {
        this.togglePanMode();
    }
    
    HandleMouseEnter = () => {
        document.body.style.overflow = "hidden";
/*         if(this.loadFirstFrame){
            this.setState({ imagesLoaded: false });
            this.loadFirstFrame = false;
            this.imageData = [];
            this.images = [];
            this.loadedImages = 0;

            this.fetchData()
        } */
    }

    HandleFocus = () => {
        if(this.loadFirstFrame){
            this.setState({ imagesLoaded: false });
            this.loadFirstFrame = false;
            this.imageData = [];
            this.images = [];
            this.loadedImages = 0;

            this.fetchData()
        }
    }

    HandleMouseLeave = () => {
        this.dragging = false
        this.dragStart = null
        this.movement = false
        this.movementStart = 0
        this.viewPortElementRef.style.cursor = 'grab'
        document.body.style.overflow = "";
    }

    pinchEnd = () => {
        //this.currentScale = 1;
        this.mobilePinching = false;

        //console.log("Pinching FALSE");
        
    }

    pinchStart = () => {
        //this.currentScale = 1;
        this.mobilePinching = true;

        //console.log("Pinching TRUE");
 

    }

    render() {
        
        return (
            <>
            <div>
                <div className="v360-viewer-container" 
                ref={(inputEl) => {this.viewerContainerRef = inputEl}} id="identifier"     
                onMouseEnter={() => this.HandleMouseEnter()}
                onMouseLeave={() => this.HandleMouseLeave()}
                onFocus={() => this.HandleFocus()}
                onWheel={(e) => this.zoomImage(e)} 
                tabIndex="0" 
                onKeyDown={this.HandleKeyDown} 
                onKeyUp={this.HandleKeyUp}>

                    {!this.state.imagesLoaded ? 
                    <div className="v360-viewport">
                        <div className="LoadingSpinnerBG">
                            <div className="LoadingSpinner">

                                <div ref={this.radialProgressRef}
                                        className="RadialProgress"
                                        role="progressbar"
                                        aria-valuenow="1"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                ></div>

                                <DBGLoadingSpinner/>
                                <p ref={this.viewPercentageRef} className="v360-percentage-text">0%</p>
                            </div>
                        </div>
                    </div> 
                    :''}

                    <Hammer onTap={this.handleTap} onPinchIn={this.handlePinch} onPinchOut={this.handlePinch} onPinchEnd={this.pinchEnd} onPinchStart={this.pinchStart}
                        options={{
                        recognizers: {
                            pinch: { enable: true },
                            tap: {
                                taps: 2,
                                time: 250
                            }
                        }
                    }}>
                        <div className="v360-viewport-container v360-viewport">
                            <canvas 
                                className="v360-image-container" 
                                ref={(inputEl) => {this.imageContainerRef = inputEl}} 
                            ></canvas>
                            {this.props.boxShadow ? <div className="v360-product-box-shadow"></div> : ''}
                        </div>
                    </Hammer>

                    <abbr title="Fullscreen Toggle">
                        <div className="v360-fullscreen-toggle text-center" onClick={this.toggleFullScreen}>
                            <div className={this.props.buttonClass === 'dark' ? 'v360-fullscreen-toggle-btn text-light' : 'v360-fullscreen-toggle-btn text-dark'}>
                                <i className={!this.state.isFullScreen ? 'fas fa-expand text-lg' : 'fas fa-compress text-lg'}></i>
                            </div>
                        </div>
                    </abbr>

                     <div className="DBG-menu" ref={(inputEl) => {this.MenuButtonContainerRef = inputEl}}>
                        {this.state.imagesLoaded === true ? 
                        <div className="DBG-navigate-btns">
                            <MenuButton 
                                clicked={this.togglePlay} 
                                icon={this.state.playing ? 'fa fa-pause' : 'fa fa-play'} 
                            />
                            {/* <MenuButton 
                                clicked={this.prev} 
                                icon="fa fa-chevron-left" 
                            />
                            <MenuButton 
                                clicked={this.next} 
                                icon="fa fa-chevron-right" 
                            /> */}
                            <MenuButton 
                                clicked={this.zoomInButton} 
                                icon="fa fa-search-plus" 
                            />
                            <MenuButton 
                                clicked={this.zoomOutButton} 
                                icon="fa fa-search-minus" 
                            />

                           {/*  {this.state.panmode ? <Button clicked={this.togglePanMode} text="360&deg;"/> : <Button clicked={this.togglePanMode} icon="fa fa-hand-paper"/>} */}
                            <MenuButton 
                                clicked={this.resetPosition} 
                                icon="fa fa-sync"
                            />
                        </div>:
                        <></>}
                    </div>

                    <div className="DBG-notification" ref={(inputEl) => {this.NotificationDivRef = inputEl}}>
                        <div className="DBG-notify">
                            <div className="DBG-NotificationMessage">
                                <i className="fa fa-hand-paper"></i><p>Panning: {this.state.panmode? "Enabled" : "Disabled"}</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            </>
        );
    }

}

export default React360Viewer;